import { NgModule } from '@angular/core';

import { HisAmountPipe } from 'hisng';

import { DocumentService } from './service/documents/document.service';
import { DocumentHelperService } from './service/documents/document-helper.service';
import { DocumentMetadataCategoryService } from './service/documents/documentMetadataCategory.service';

import { CommonSharedModule } from './common-shared.module';
import { AmountUtils } from './utils/amount-utils';
import { CssClassUtils } from './utils/css-class-utils';
import { DateUtils } from './utils/date-utils';
import { FinancingTypeValueService } from './service/financing-type/financing-type-value.service';
import { DynamicContentService } from './service/dynamic-content/dynamic-content.service';
import { DynamicClassService } from './service/dynamic-content/dynamic-class.service';
import { DynamicComponentUtils } from './service/dynamic-content/dynamic-component-utils';
import { DynamicFieldValueUtils } from './service/dynamic-content/dynamic-field-value.utils';
import { DataDictionaryUtils } from './utils/data-dictionary-utils';
import { ProviderManager } from './utils/provider-manager';
import { RightsService } from './service/rights/rights.service';
import { ProjectDueDateService } from '../finance/service/project/project-due-date.service';

/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
        CommonSharedModule,
    ],
    declarations: [
    ],
    exports: [
        CommonSharedModule,
    ],
    providers: [
        HisAmountPipe,

        FinancingTypeValueService,
        // documents
        DocumentService,
        DocumentHelperService,
        DocumentMetadataCategoryService,
        // dynamic stuff
        DynamicContentService,
        DynamicClassService,
        ProjectDueDateService,

        // rights
        RightsService,
        
        // utils
        AmountUtils,
        CssClassUtils,
        DateUtils,
        DynamicComponentUtils,
        DynamicFieldValueUtils,
        DataDictionaryUtils,
        ProviderManager,
    ],
} )

export class CommonCoreModule {
}
